const Navbar = () => {
  return (
    <div className='flex justify-between mx-8 my-10'>
      {" "}
      <img
        src='https://demo.templatetrend.com/magento/Euforia/images/header-logo.png'
        alt=''
      />
      <h3 className='text-2xl text-gray-400'>
        Creative design, ultimate core features and ease of customization
      </h3>
    </div>
  );
};

export default Navbar;
